import React from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";

export const Aboutus = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="font-[Roboto] grow">
        <div className="text-white text-2xl py-8 sm:px-12 px-4 flex items center bg-[#2EBAA3]">
          <span>About Us</span>
        </div>
        <div className="sm:px-12 px-4 font-light my-4 text-justify leading-relaxed">
          ProLegion was founded by a group of highly experienced Information Technology
          industry Consultants, with a collective experience of over 25+ years. With a
          deep understanding of the diverse range of information technology solutions
          available in the marketplace, ProLegion is a dedicated platform that directly
          connects IT Consultants, Clients, and Vendors. Whether you are seeking the
          right specialist to assist your company with various software solutions or
          are an experienced IT consultant looking to provide services to clients
          worldwide, ProLegion is the ultimate hassle-free destination tailored to your
          specific needs.
        </div>
        <div className="sm:px-12 px-4 font-light my-4 text-justify leading-relaxed">
          Here's how it works: As an IT Consultant, you can easily create your profile
          and apply for the jobs/projects that pique your interest. As an IT Client,
          you gain the ability to post your jobs/projects and leverage ProLegion's
          ProReview Process, which deploys IT Experts to assist you in selecting the
          expert or firm that best matches your unique IT requirements. As an IT
          Vendor, you have the flexibility to post projects, find consultants to
          complement your team, or engage underutilized staff with short-term work
          opportunities. Our ProReview process infuses a human touch, enabling
          stakeholders to engage with our platform seamlessly.
        </div>
        <div className="sm:px-12 px-4 font-light my-4 text-justify leading-relaxed">
          Whether you are in need of an IT Resource, IT Vendor, or IT Solution, ProLegion
          is the comprehensive solution you seek. We prioritize privacy and security,
          ensuring that your information is always respected. Our commitment is to maintain
          ProLegion as a platform where complex work is efficiently accomplished.
        </div>
        <div className="sm:px-12 px-4 font-light my-4 text-justify leading-relaxed">
          Feel free to customize the revised paragraph according to your specific preferences
          and requirements.
        </div>
      </div>
      <Footer />
    </div>
  );
};
